import { ChangeEvent } from "react";
import { read, utils } from "xlsx";
import { ISKUCreateItem, ISKUCreateItemExcel, ISKUStatus } from "../interfaces/sku";
import { BASE_URL, BULK_UPDATE_CREATE, EXCLUSIONS, INPUT_FORMS, NEWLISTANDDELIST, SKU_PERF, SKU_PERF_BY_COUNTRY, STATUSES } from "../../../constant/apiEndpoints";
import APIService from "../../../services/APIService";


export const getPrevQuarter = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentQuarter = Math.floor(currentMonth / 3) + 1;
    let previousQuarterStart;
    if (currentQuarter === 1) {
        previousQuarterStart = new Date(currentYear - 1, 9, 1);
    }
    else {
        previousQuarterStart = new Date(currentYear, (currentQuarter - 2) * 3, 1);
    }
    const formattedPreviousClosedQuarter = `${previousQuarterStart.getFullYear()}Q${Math.floor(previousQuarterStart.getMonth() / 3) + 1}`;

    return formattedPreviousClosedQuarter
}

export const constructMassUploadData = async (e:ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, formId:string) => {
    const { files } = e.currentTarget as HTMLInputElement;

    const file = files?.[0];
    const sheetName = "SKU Exclusions";

    let typesList:ISKUStatus[] = [];

    const statusesURL = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + STATUSES + '?selected_form=formsku'
    const response:any = await new APIService().get(statusesURL);

    if (response.error) {
        console.log("error in Brand List API", response.results.message)
    } else {
        typesList = response.results;
    }

    if (file) {
        const ab = await file.arrayBuffer();
        const wb = read(ab);
        const exclusions = wb.Sheets[sheetName] || wb.Sheets[wb.SheetNames[0]];
        const exclusionsData:ISKUCreateItemExcel[] = utils.sheet_to_json(exclusions);

        const prevQ = getPrevQuarter();

        const tempData = exclusionsData.reduce((all:ISKUCreateItem[], item:ISKUCreateItemExcel) => {
            const oldPeriod = item.Quarter?.split(" ") || [];
            const newPeriod = item["Quarter(Newlist/Delist)"]
                ? item["Quarter(Newlist/Delist)"].split(" ")
                : item["Quarter"]?.split(" ") || [];
            const type = typesList.find(({reference_title}) => reference_title === item["Exclusion Type"])
            
            if (newPeriod.length > 0 && oldPeriod.length > 0 && type) {
                return [
                    ...all,
                    {
                        ban_number: item["BAN Number"],
                        ...(formId === 'formsku'
                            ? {business_unit: item["Business Unit"]}
                            : {country: item["Country"]}
                        ),
                        category: item['Category'],
                        form_id: formId,
                        new_time_frame: newPeriod[1],
                        new_year: Number(newPeriod[0]),
                        time_frame: oldPeriod[1],
                        type: type.id,
                        reference_title: type.reference_title,
                        year: Number(oldPeriod[0]),
                    }
                ];
            }
            
            return all
        }, []);

        const url = BASE_URL + INPUT_FORMS + (formId === 'formsku' ? SKU_PERF : SKU_PERF_BY_COUNTRY) + EXCLUSIONS + NEWLISTANDDELIST + BULK_UPDATE_CREATE + `?selected_form=${formId}`;
        const response:any = await new APIService().post(url, tempData);
    
        return response;
    }
}